module.exports = __webpack_public_path__ + "img/imgBebeWinCoupon.19960827.png";